import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Folder from "../../../atoms/Folder";
import Heading from "../../../atoms/Heading";
import { foldersInfo, foldersUserInfo } from "../../../../utils/foldersInfo";
import { useSession } from "../../../../context/SessionContext";

const InmuebleAccesosDirectos = ({ inmueble }) => {
    const { user } = useSession();

    let folders;

    if (user?.role === "Resident") {
        folders = foldersUserInfo;
    } else if (user?.role === "GeneralAdmin") {
        folders = foldersInfo
    };

    const navigate = useNavigate();

    const handleClick = (folder) => {
        if (folder.condition()) {
            navigate(folder.route);
        } else {
            toast.error(folder.error || "Acceso no disponible.");
        }
    };

    return (
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            {typeof folders === "function" ?
                folders(inmueble)?.filter(folder => folder.condition())?.map((folder) => (
                    <Folder
                        key={folder?.route}
                        bgColor={folder.bg}
                        onClick={() => handleClick(folder)}
                        children ={
                            <div className="h-full flex flex-col justify-around items-center">
                                <Heading text={folder.text} color="white" />
                                {React.createElement(folder.icon, { size: 75, color: "white" })}
                            </div>
                        }
                    />
                ))
            : null}
        </div>
    );
};

export default InmuebleAccesosDirectos;